import React from 'react';
import { createRoot } from 'react-dom/client';
import BarcodeGenerator from './components/BarcodeGenerator';



const rootElement = document.getElementById('root');

createRoot(rootElement).render(
  <React.StrictMode>
    <BarcodeGenerator />
  </React.StrictMode>
);
